import React, { useEffect } from 'react';
import { Toaster as HotToaster, useToaster, toast } from 'react-hot-toast';

/**
 * Custom themed Toaster that matches the app's dark UI.
 * Limits the stack to one toast at a time as per UX requirements.
 */
const Toaster: React.FC = () => {
  const { toasts } = useToaster();

  // Limit the toast stack to one at a time
  useEffect(() => {
    toasts
      .filter((t) => t.visible) // Only consider visible toasts
      .filter((_, i) => i > 0) // All except the newest (first in array)
      .forEach((t) => toast.dismiss(t.id)); // Dismiss older ones
  }, [toasts]);

  return (
    <HotToaster
      position="top-right"
      gutter={10}
      // Keep toasts above modal overlays (Dialogs use z-[9999], inner popovers up to z-[999999])
      containerStyle={{ zIndex: 1000000 }}
      toastOptions={{
        duration: 4000,
        // Base styles for ALL toasts
        style: {
          background: '#1C1F2A',
          color: '#E2E8F0',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '10px',
          fontSize: '13px',
          fontWeight: 500,
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          padding: '12px 16px',
          maxWidth: '380px',
        },
        // Success variant
        success: {
          iconTheme: {
            primary: '#22C55E',
            secondary: '#1C1F2A',
          },
          style: {
            background: '#1C1F2A',
            border: '1px solid rgba(34,197,94,0.25)',
            color: '#E2E8F0',
          },
        },
        // Error variant
        error: {
          iconTheme: {
            primary: '#EF4444',
            secondary: '#1C1F2A',
          },
          style: {
            background: '#1C1F2A',
            border: '1px solid rgba(239,68,68,0.25)',
            color: '#E2E8F0',
          },
        },
      }}
    />
  );
};

export default Toaster;
